import React from 'react';
import { FormWrapperDesktop } from '@alfa-bank/site-form-wrapper/desktop';

import type { TDesktop } from '../models';
import { Form } from '../form';

/** Адаптер рамки формы, чтобы убрать рамку из Form */
export const FormWrapperAdapter = ({
    className,
    showFormOuterWrapper = true,
    view = 'shadow',
    ...proxyProps
}: TDesktop) => {
    if (showFormOuterWrapper) {
        return (
            <FormWrapperDesktop className={className} shadow={view === 'shadow'}>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <Form {...proxyProps} />
            </FormWrapperDesktop>
        );
    }

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Form className={className} {...proxyProps} />;
};
